/* global axios */
import ApiClient from '../ApiClient';

class PilotWechatCrawlArticles extends ApiClient {
  constructor() {
    super('pilot/wechat_crawl_articles', { accountScoped: true });
  }

  // 获取文章列表
  // params: { status, search, page, knowledgeBaseId, scope }
  get({ status, search, page = 1, knowledgeBaseId, scope } = {}) {
    const params = { page };
    if (status) params.status = status;
    if (search) params.search = search;
    if (knowledgeBaseId) params.knowledge_base_id = knowledgeBaseId;
    if (scope) params.scope = scope;
    return axios.get(this.url, { params });
  }

  // 更新文章（手动保存到知识库）
  update(id, knowledgeBaseId) {
    return axios.put(`${this.url}/${id}`, {
      knowledge_base_id: knowledgeBaseId,
    });
  }

  // 删除单条文章
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // 批量删除文章
  batchDestroy(ids) {
    return axios.post(`${this.url}/batch_destroy`, { ids });
  }

  // 批量指定到知识库
  batchUpdate(ids, knowledgeBaseId) {
    return axios.put(`${this.url}/batch_update`, {
      ids,
      knowledge_base_id: knowledgeBaseId,
    });
  }
}

export default new PilotWechatCrawlArticles();
